export function getFileObjectUniqueKey(file: File) {
	return `${file.name}_${file.size}_${file.lastModified}`
}

export function getFormattedFileSize(size: number) {
	const parts = getFormattedFileSizeParts(size)

	return `${parts.value} ${parts.postfix}`
}

export function getFormattedFileSizeParts(size: number, precision = 1) {
	let value = size
	let postfix = 'bytes'

	if (size < 1e3) {
		value = size
		postfix = 'bytes'
	} else if (size >= 1e3 && size < 1e6) {
		value = Number((size / 1e3).toFixed(precision))
		postfix = 'KB'
	} else {
		value = Number((size / 1e6).toFixed(precision))
		postfix = 'MB'
	}

	return { value, postfix }
}

export type FileSizeUnit = 'bytes' | 'kb' | 'mb'

export function getFileSizeDisplayUnit(size: number): FileSizeUnit {
	if (size < 1e3) {
		return 'bytes'
	} else if (size >= 1e3 && size < 1e6) {
		return 'kb'
	}

	return 'mb'
}

export function getFormattedFileSizeInUnit(size: number, unit: FileSizeUnit, precision = 1) {
	let value = size

	switch (unit) {
		case 'kb':
			value = Number((size / 1e3).toFixed(precision))
			break

		case 'mb':
			value = Number((size / 1e6).toFixed(precision))
			break

		default:
			break
	}

	return value
}

export function formatFileSizeUnitForDisplay(unit: FileSizeUnit) {
	return unit === 'bytes' ? unit : unit.toUpperCase()
}

export function getMimeTypeFromFilename(filename: string) {

	const extension = filename.split('.')?.pop()?.toLowerCase()

	if (!extension) return null

	const mimeTypes: Record<string, string> = {
		mp4: 'video/mp4',
		webm: 'video/webm',
		ogg: 'video/ogg',
		mov: 'video/quicktime',
		avi: 'video/x-msvideo',
		mpeg: 'video/mpeg',
		mkv: 'video/x-matroska',
		// Add more as needed
	}

	return mimeTypes[extension] || 'application/octet-stream'

}